import React  , {useRef} from "react";





function TableRowsTax({rowsData }) {

  
    return(
        
        rowsData.map((data, index)=>{
            const {tax , amount}= data;
            return(
                <tr key={index}>

                    <td><input
                          className="form-control form-control-lg"
                          type="text"
                          style={{"width" : "130px"}}
                          name="tax"
                         
                         disabled
                          value={tax} 
                        /> </td>


                            <td><input style={{"width" : "100px"}}
                             disabled
                          className="form-control form-control-lg"
                          type="text"
                          name="amount"
                          value={amount}
                       
                        />
                         </td>

                         
            </tr>
            )
        })
   
    )
    
}
export default TableRowsTax;